/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react';
import { FC, SVGProps } from 'react';

const WabaQualityRatingLow: FC<SVGProps<SVGSVGElement> & { size?: number }> = ({
  size = '24px',
  ...props
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={16}
      height={16}
      fill="none"
      {...props}
    >
      <mask
        id="a"
        width={16}
        height={16}
        x={0}
        y={0}
        maskUnits="userSpaceOnUse"
        css={css`
          mask-type: alpha;
        `}
      >
        <path
          fill="#C21313"
          d="M10.8 0c.664 0 1.2.544 1.2 1.219V11.78c0 .675-.536 1.219-1.2 1.219-.664 0-1.2-.544-1.2-1.219V1.22C9.6.544 10.136 0 10.8 0ZM1.2 8.125c.664 0 1.2.544 1.2 1.219v2.437C2.4 12.456 1.864 13 1.2 13 .536 13 0 12.456 0 11.781V9.344c0-.675.536-1.219 1.2-1.219ZM6 4.062c.664 0 1.2.545 1.2 1.22v6.5C7.2 12.455 6.664 13 6 13c-.664 0-1.2-.544-1.2-1.219v-6.5c0-.674.536-1.218 1.2-1.218Z"
        />
      </mask>
      <g fill="#C21313" mask="url(#a)">
        <path d="M-.86 0h4v13h-4z" />
        <path fillOpacity={0.32} d="M-.86 0h13v13h-13z" />
      </g>
    </svg>
  );
};

export default WabaQualityRatingLow;
